import RestService from "./RestService";



export default class StatusService extends RestService {
    constructor() {
        super('/status/services')
    }

    // 3rd-party service status check is non-essential. A 401/403 from this
    // endpoint says nothing about the user's session, so opt out of the
    // global 401 -> logout behavior in BaseService.
    fetch(language) {
        return this.get(`${this.baseUrl}/${language}`, undefined, { skipAuthHandling: true })
    }

}
